<template>
  <div>
    <v-card outlined>
      <v-card-text>
        <v-row no-gutters>
          <v-col>
            <v-row justify="left">
              <v-col md="4">
                <v-text-field
                  v-model="filter.search"
                  placeholder="Поиск по номеру карты или ФИО"
                  dense
                />
              </v-col>
              <v-col>
                <v-btn @click="modals.card = true">Выдача карты</v-btn>
              </v-col>
              <v-col>
                <UploadFileButton
                  :title="'Импорт сотрудников'"
                  @upload="uploadTeachers"
                />
                <UploadFileButton
                  :title="'Импорт учеников'"
                  @upload="uploadPupils"
                />
              </v-col>
            </v-row>
          </v-col>
          <v-col>
            <v-row justify="end">
              <v-col>
                <Select
                  v-model="filter.state"
                  :items="states"
                  label="Статус:"
                  class="fs-admin-complex-autocomplete"
                  @change="getDataFromFirstPage"
                  flat
                  dense
                  blank
                />
              </v-col>
              <v-col>
                <Select
                  v-model="filter.district"
                  :items="districts"
                  item-text="short_name"
                  item-value="id"
                  label="Муниципалитет:"
                  class="fs-admin-complex-autocomplete"
                  @change="loadSchools"
                  flat
                  dense
                  blank
                />
                <Select
                  v-if="filter.district !== null"
                  v-model="filter.school"
                  label="Школа:"
                  :items="schools"
                  item-text="short_name"
                  item-value="id"
                  class="fs-admin-complex-autocomplete"
                  @change="loadClasses"
                  flat
                  dense
                  blank
                />
              </v-col>
              <v-col>
                <Select
                  label="Тип карты"
                  v-model="filter.role"
                  :items="roles"
                  item-value="id"
                  item-text="name"
                  @change="getDataFromFirstPage"
                  dense
                  blank
                />
                <Select
                  v-if="filter.school !== null"
                  label="Класс/должность"
                  v-model="filter.school_class"
                  :items="school_classes"
                  item-value="id"
                  item-text="name"
                  @change="getDataFromFirstPage"
                  dense
                  blank
                />
              </v-col>
              <v-col>
                <DatePicker
                  labelText="Дата выдачи"
                  :dateValue.sync="filter.started_at"
                  v-model="filter.started_at"
                  @changeDate="getDataFromFirstPage"
                  dense
                />
                <DatePicker
                  labelText="Срок действия"
                  :dateValue.sync="filter.expired_at"
                  @changeDate="getDataFromFirstPage"
                  v-model="filter.expired_at"
                  dense
                />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <Table
              v-model="selectedCards"
              :headers="headers"
              :items="cards"
              :loading="loading"
              :items-per-page="cardsPerPage"
              :server-items-length="totalCards"
              :sort-by="sort.field"
              :sort-desc="sort.desc"
              :page="page"
              @update:request="updateRequest"
              @update:sort-by="updateSortField"
              @update:sort-desc="updateSortDesc"
              item-key="id"
              class="elevation-1"
              show-select
            >
              <template v-slot:item.is_in="{ item }">
                <v-icon v-if="item.is_in">check</v-icon>
                <v-icon v-else>cancel</v-icon>
              </template>
              <template v-slot:item.status="{ item }">
                {{ getCardStatus(item) }}
              </template>
              <template v-slot:item.roles="{ item }">
                {{ item.roles.map(r => r.name ).join(', ') }}
              </template>
              <template v-slot:item.started_at="{ item }">
                {{ item.started_at | dateTime }}
              </template>
              <template v-slot:item.expired_at="{ item }">
                {{ item.expired_at | dateTime }}
              </template>
              <template v-slot:item.edit="{ item }">
                <v-btn
                  text
                  icon
                  x-small
                >
                  <v-icon @click="editCardModalOpen(item)">edit</v-icon>
                </v-btn>
              </template>
            </Table>
          </v-col>
        </v-row>
        <v-row v-if="selectedCards.length">
          <v-col>
            <v-btn @click="modals.block = true">Блокировка</v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <ConfirmModal
      :dialog.sync="modals.block"
      :contentClass="'esh-theme adminModal'"
      :title="'Внимание'"
      :confirmBtnText="'Заблокировать'"
      @confirm="blockSelectedCards"
    >
      <template #body>
        <v-col>
          <v-row>
            Вы действительно хотите заблокировать выбранные карты?
          </v-row>
          <v-row>
            <v-select
              v-model="blockCards.blockReason"
              label="Причина"
              :items="blockReasons"
              item-value="alias"
              item-text="name"
              return-object
            />
          </v-row>
          <v-row>
            <v-textarea
              v-if="blockCards.blockReason === customBlockReason"
              v-model="blockCards.reasonText"
              placeholder="Введите причину блокировки"
              class="mt-1"
              auto-grow
              outlined
            />
          </v-row>
        </v-col>
      </template>
    </ConfirmModal>
    <EditCardModal
      :card="selectedCard"
      :showCardModal.sync="modals.edit"
      :editCard="EDIT_CARD"
      :blockCard="BLOCK_CARD"
      :unlockCard="UNLOCK_CARD"
      @onSaveEditedCard="onSaveEditedCard"
    />
    <NewCardModal
      :showCardModal.sync="modals.new"
      :user="foundedUser"
      @card:save="createCard($event)"
    />
    <CardFindUserModal
      :show.sync="modals.card"
      @user="foundUser($event)"
    />
    <Modal
        v-if="uploadErrors.show"
        :dialog.sync="uploadErrors.show"
        :title="'Ошибки'"
        @handler="uploadErrors.show = false; uploadErrors.errors = []"
        contentClass="esh-theme adminModal"
        btnText="Ок"
        btnIcon="done_all"
        :width="600"
    >
      <template #body>
        <ul>
          <li v-for="error in uploadErrors.errors" :key="error">
            {{ error }}
          </li>
        </ul>
      </template>
    </Modal>
  </div>
</template>
<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import { BASE, FORMAT } from '@/config'
import {
  DatePicker,
  ConfirmModal,
  Table,
  Select,
  UploadFileButton
} from '@/components/common'
import EditCardModal from '@/components/cards/EditCardModal'
import NewCardModal from '@/components/cards/NewCardModal'
import CardFindUserModal from '@/views/superadmin/card/CardFindUserModal'
import {
  GET_CARDS,
  BLOCK_CARD,
  BLOCK_CARDS,
  UNLOCK_CARD,
  EDIT_CARD,
  CREATE_CARD,
  GET_SUGGESTION_CLASSES,
  GET_SUGGESTION_MUNICIPALITIES,
  GET_SUGGESTION_SCHOOLS,
  UPLOAD_TEACHERS,
  UPLOAD_PUPILS
} from '@/requests/superadmin'
import { Modal } from '@/components/common'
import moment from 'moment'

const GUEST_ROLE = -1
const GUEST_ROLE_DATA = { name: 'Гостевая', id: GUEST_ROLE }

export default {
  name: 'CardsManagementSuperAdmin',
  components: {
    DatePicker,
    Table,
    Select,
    ConfirmModal,
    EditCardModal,
    NewCardModal,
    CardFindUserModal,
    UploadFileButton,
    Modal
  },
  data: () => ({
    BLOCK_CARD,
    UNLOCK_CARD,
    EDIT_CARD,
    GUEST_ROLE,
    headers: [
      { text: 'Присутстствие', value: 'is_in', sortable: false },
      { text: 'ID', value: 'number', sortable: false },
      { text: 'ID HEX', value: 'hex_number', sortable: false },
      { text: 'Тип карты', value: 'roles', sortable: false },
      { text: 'Статус', value: 'status', sortable: false },
      { text: 'ФИО', value: 'name', sortable: false },
      { text: 'Класс/должность', value: 'className', sortable: false },
      { text: 'Дата выдачи', value: 'started_at' },
      { text: 'Срок действия', value: 'expired_at' },
      { text: 'Примечание', value: 'note', sortable: false },
      { text: 'Школа', value: 'unit.name', sortable: false, width: '15%' },
      { text: 'Муниципалитет', value: 'municipality.name', sortable: false, width: '15%' },
      { text: 'Редактировать', value: 'edit', sortable: false }
    ],
    modals: {
      card: false,
      new: false,
      edit: false,
      block: false
    },
    blockCards: {
      blockReason: null,
      reasonText: ''
    },
    states: [
      { text: 'Активна', value: 'is_active' },
      { text: 'Заблокирована', value: 'is_blocked' },
      { text: 'Истек срок действия', value: 'is_expired' }
    ],
    cards: [],
    cardsPerPage: BASE.LIMIT,
    totalCards: 0,
    page: 1,
    offset: 0,
    selectedBlockReason: null,
    rules: {
      required: value => !!value || 'Заполните обязательно!'
    },
    selectedCard: {},
    selectedCards: [],
    school_classes: [],
    districts: [],
    schools: [],
    loading: false,
    filter: {
      search: '',
      role: null,
      school_class: null,
      started_at: null,
      expired_at: null,
      district: null,
      school: null,
      state: null
    },
    sort: {
      field: undefined,
      desc: undefined
    },
    foundedUser: null,
    uploadErrors: {
      show: false,
      errors: []
    }
  }),
  mounted() {
    this.blockCards.blockReason = this.blockReasons[0]
    this.loadDistricts()
    if (localStorage.CardsManagementViewFilters) {
      let filters = null;
      try {
        filters = JSON.parse(localStorage.CardsManagementViewFilters)
      } catch (e) {
        console.error(e)
        return
      }
      for (const [key, value] of Object.entries(filters)) {
        this.filter[key] = value
      }
      this.doLoadSchools()
      this.doLoadClasses()
    }
    this.getData()
  },
  computed: {
    ...mapState({
      blockReasons: state => state.common.constants.card_block_reasons,
      customBlockReason: state =>
        state.common.constants.card_block_reasons.find(
          r => r.alias === 'CUSTOM'
        ),
      cardRoles: state => state.common.constants.card_roles,
      PUPIL_ROLE_DATA: state =>
        state.common.constants.card_roles.find(r => r.alias === 'PUPIL'),
      roleChoices: state => state.common.constants.role_choices
    }),
    roles() {
      return [...this.cardRoles, GUEST_ROLE_DATA]
    }
  },
  watch: {
    'modals.block': function(state) {
      if (state) {
        this.blockCards.blockReason = this.blockReasons[0]
        this.blockCards.reasonText = ''
      }
    },
    'filter.search': function(state, prevState) {
      if (
        state.length > prevState.length &&
        state.length >= BASE.SEARCH_MIN_LETTERS
      ) {
        this.searchCards()
      } else if (
        state.length < prevState.length &&
        prevState.length >= BASE.SEARCH_MIN_LETTERS
      ) {
        this.searchCards()
      }
    },
    filter: {
      deep: true,
      handler(state) {
        localStorage.CardsManagementViewFilters = JSON.stringify(state)
      }
    },
  },
  methods: {
    updateRequest({ page, itemsPerPage, offset }) {
      this.cardsPerPage = itemsPerPage
      this.page = page
      this.offset = offset
      this.getData({ offset })
    },
    updateSortDesc(desc) {
      this.sort.desc = Array.isArray(desc) ? desc[0] : desc
      this.getDataFromFirstPage()
    },
    updateSortField(field) {
      this.sort.field = Array.isArray(field) ? field[0] : field
    },
    searchCards: debounce(function() {
      this.getDataFromFirstPage()
    }, 300),
    getDataFromFirstPage() {
      this.page = 1
      this.getData()
    },
    foundUser(user) {
      this.foundedUser = user
      this.modals.new = true
      this.modals.card = false
    },
    editCardModalOpen(item) {
      this.selectedCard = item
      this.modals.edit = true
    },
    onSaveEditedCard() {
      this.getData({ offset: this.offset })
    },
    getCardStatus(c) {
      return c.is_blocked || c.is_expired
        ? c.is_blocked
          ? 'Заблокирована'
          : 'Истек срок действия'
        : 'Активна'
    },
    formatCard(c) {
      return {
        ...c,
        roles: !c.user
          ? [GUEST_ROLE_DATA]
          : c.user.roles.map(r => this.roleChoices.find(role => role.id === r)),
        name: !c.user ? c.full_name : c.user.full_name,
        className: !c.user
          ? null
          : c.user.school_class && c.user.school_class.name
      }
    },
    async loadClasses() {
      this.filter.school_class = null
      this.getDataFromFirstPage()

      await this.doLoadClasses()
    },
    async uploadTeachers(file) {
      const formData = new FormData()
      formData.append('file', file)
      try {
        const { data } = await UPLOAD_TEACHERS(formData)
        this.showUploadResult(data)
      } catch {
        this.$notify({
          type: 'error',
          text: 'Не удалось загрузить информацию о cотрудниках'
        })
      }
    },
    async uploadPupils(file) {
      const formData = new FormData()
      formData.append('file', file)
      try {
        const { data } = await UPLOAD_PUPILS(formData)
        this.showUploadResult(data)
      } catch {
        this.$notify({
          type: 'error',
          text: 'Не удалось загрузить информацию об учениках'
        })
      }
    },
    showUploadResult(data) {
      const { errors, cards } = data
      this.uploadErrors.errors = []
      if (errors && errors.length > 0) {
        this.uploadErrors.errors = errors
        this.uploadErrors.show = true
      }
      if (cards && cards.length > 0) {
        this.$notify({
          type: 'success',
          text: `Загружено ${cards.length} карт`
        })
      }
    },
    async getData(params = {}) {
      try {
        this.loading = true
        const {
          data: { results, count }
        } = await GET_CARDS({
          limit: this.cardsPerPage,
          search:
            this.filter.search.length >= BASE.SEARCH_MIN_LETTERS
              ? this.filter.search
              : '',
          ordering: this.sort.field
            ? `${this.sort.desc ? '-' : ''}${this.sort.field}`
            : null,
          role: this.filter.role !== GUEST_ROLE ? this.filter.role : null,
          is_guest: this.filter.role === GUEST_ROLE || null,
          started_at: !this.filter.started_at
            ? null
            : moment(this.filter.started_at).format(FORMAT.datepickerDate),
          expired_at: !this.filter.expired_at
            ? null
            : moment(this.filter.expired_at).format(FORMAT.datepickerDate),
          school_class: this.filter.school_class,
          district: this.filter.district,
          unit: this.filter.school,
          is_active: this.filter.state === 'is_active' || null,
          is_blocked: this.filter.state === 'is_blocked' || null,
          is_expired: this.filter.state === 'is_expired' || null,
          ...params
        })

        this.totalCards = count
        this.cards = results.map(c => this.formatCard(c))
      } catch (error) {
        this.$notify({
          type: 'error',
          text: 'Не удалось загрузить информацию о картах'
        })
      } finally {
        this.loading = false
        this.selectedCards = []
      }
    },
    async createCard(card) {
      try {
        await CREATE_CARD({ ...card, unit: this.foundedUser.unit })
        this.getData()
        this.$notify({
          type: 'success',
          text: `Карта №${card.number} успешно создана!`
        })
      } catch (error) {
        console.log(error)
        this.$notify({
          type: 'error',
          text: 'Не удалось создать новую карту'
        })
      }
    },
    async blockSelectedCards() {
      this.modals.block = false
      try {
        const ids = this.selectedCards.map(card => card.id)
        const payload = {
          ids: ids,
          reason: this.blockCards.blockReason.id,
          reason_text:
            this.blockCards.reasonText || this.blockCards.blockReason.name
        }
        await BLOCK_CARDS(payload)
        this.$notify({
          type: 'success',
          text: 'Карты успешно заблокированы!'
        })
      } catch {
        this.$notify({
          type: 'error',
          text: 'Неуспешное блокирование карт!'
        })
      } finally {
        this.getData()
      }
    },
    async loadDistricts() {
      try {
        let { data } = await GET_SUGGESTION_MUNICIPALITIES()
        this.districts = data.results
      } catch {
        this.$notify({
          type: 'error',
          text: 'Не удалось загрузить муниципалитеты'
        })
      }
    },
    async loadSchools() {
      this.filter.school = null
      this.getDataFromFirstPage()

      await this.doLoadSchools()
    },
    async doLoadSchools() {
      if (!this.filter.district) {
        this.schools = []
        return
      }

      try {
        const {
          data: { results }
        } = await GET_SUGGESTION_SCHOOLS({
          district: this.filter.district
        })

        this.schools = results
      } catch {
        this.$notify({
          type: 'error',
          text: 'Не удалось загрузить школы'
        })
      }
    },
    async doLoadClasses() {
      if (!this.filter.district || !this.filter.school) {
        this.school_classes = []
        return
      }

      try {
        const {
          data: { results }
        } = await GET_SUGGESTION_CLASSES({
          unit: this.filter.school
        })

        this.school_classes = results
      } catch {
        this.$notify({
          type: 'error',
          text: 'Не удалось загрузить информацию о классах'
        })
      }
    }
  }
}
</script>
